module.exports = __webpack_public_path__ + "img/login_bg.5338bd22.png";